import script from "./ParticleField.vue?vue&type=script&setup=true&lang=js"
export * from "./ParticleField.vue?vue&type=script&setup=true&lang=js"

import "./ParticleField.vue?vue&type=style&index=0&id=2e0d5a91&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e0d5a91"]])

export default __exports__